import { getDecryptedContentFromIndexedDb } from "../db/indexed-helper";
import { getBlockedList } from '../helper/settingsHelper.js';
import { getInsecure, isApiError } from "../service/api-actions.js"
import { getHostHelperContract } from "./contract-helper.js";
export const formatMessageList = async (messageList, type = "no_data") => {
    const allList = [];
    const readList = [];
    const unReadList = [];
    const deletedList = [];
    const archiveList = [];
    const getBlocked = await getBlockedList();
    const blockedAddresses = getBlocked.address ? getBlocked.address.split(',') : [];
    for (let msg of messageList) {
        const idformat = (type === 'Insecure' || msg.mailtype === 'web2emails') ? msg.id : parseInt(msg.id);
        const decryptedMessage = await getDecryptedContentFromIndexedDb(idformat, type.toLowerCase());
        if (msg) {
            if (blockedAddresses.includes(msg.sender)) {
                continue;
            }

            if (msg?.attributes) {
                for (const element of msg?.attributes) {
                    msg[element.key] = element.value === 'true' || element.value === 'false'
                        ? JSON.parse(element.value)
                        : element.value;
                }
            }

            const returnObject = {
                messageId: idformat,
                subject: msg.subject,
                encryptedMsg: msg.encryptedData,
                date: msg.receivedDate,
                emailHeader: msg.emailDetails,
                read: msg.isRead,
                important: msg.isStarred,
                bcc: msg.isBCC,
                cc: msg.isCC,
                sender: msg.senderName,
                isStarred: msg.isStarred,
                decryptedMessage: decryptedMessage,
                ...msg
            };
            if (type === 'Trash') {
                returnObject.emailType = 'inboxtrash';

            } else if (type === 'Senttrash') {
                returnObject.emailType = 'Senttrash';
                returnObject.isPermanentDeleted = msg.isPermanentDeleted;
            }

            if (msg && !msg.isDeleted) {
                allList.push(returnObject);
                if (msg.isRead) {
                    readList.push(returnObject);
                } else {
                    unReadList.push(returnObject);
                }
            } else {
                deletedList.push(returnObject);
            }
        }
    }

    return { allList, readList, unReadList, deletedList };
}
export const getWeb2emails = async (user, type = "no_data") => {
    try {
        const insecureList = await getInsecure(user);
        // Failed fetch → straight to the catch below, which returns the honest empty list. Without this
        // the failure sentinel would fall through to `insecureList.res?.map(...)` and throw a bare
        // TypeError there instead, hiding what actually went wrong from the error report.
        if (isApiError(insecureList)) {
            throw new Error(insecureList.message || 'Failed to load Web2 emails');
        }
        const helperContract = getHostHelperContract();
        const attributes = await helperContract.methods.getAttributes(user).call();
        const formattedresponse = await Promise.all(insecureList.res?.map(async (email) => {
            const idformat = email.parts[0].message_id;
            const decryptedMessage = await getDecryptedContentFromIndexedDb(idformat, type.toLowerCase());
            const data = JSON.parse(email.parts[0].data);
            const encrypted_data = data.encrypted_data;
            const emailDetails = JSON.parse(data.email_details[2]);
            const sender = emailDetails.sender;
            const subject = emailDetails.subject;
            const folder = emailDetails.folder || '';
            const isRead = email.parts[0].status !== 0;
            const isFav = email.parts[0].fav === 1 ? true : false;
            const isArchive = email.parts[0].is_achieve;
            const deleteemails = email.parts[0].deleted_flag;
            const physmessage_id = email.physmessage_id;
            const trashtype = type === "Trash" ? "Trash" : null;
            attributes.filter((att) => {
                return parseInt(att.id) === parseInt(email.physmessage_id);
            });
            const formatedDate = {
                type: trashtype,
                mailtype: "web2emails",
                created_at: email.parts[0].internal_date,
                receivedDate: email.parts[0].internal_date,
                id: email.parts[0].message_id,
                encryptedMsg: encrypted_data,
                encryptedData: encrypted_data,
                isStarred: isFav,
                sender: sender,
                senderName: sender,
                subject: subject,
                isRead: isRead,
                header: data.email_details[2],
                emailDetails: data.email_details[2],
                isCC: false,
                isBCC: false,
                isDeleted: false,
                isArchive,
                delete: deleteemails,
                physmessage_id,
                folder: folder,
                decryptedMessage: decryptedMessage,
                isfolder: (attributes.filter((att) => (att.attType === "folder") && parseInt(att.id) === parseInt(email.physmessage_id))[0])?.value ?? false,
            };
            return formatedDate;
        }));
        return formattedresponse;
    } catch (err) {
        console.log(err);
        // Every caller (Trash / Important / Archive / Folders / Navbar) immediately .filter()s or
        // formatMessageList()s this result. Returning undefined from here therefore threw a TypeError inside
        // the caller's own try, which skipped the caller's setLoader(false) and left those folders spinning
        // forever. An empty array is the honest "no Web2 mail available" answer and keeps the Web3 mail the
        // caller already fetched visible.
        return [];
    }

}

export const formatEmailDetails = async (emailDetails) => {
    return emailDetails?.map((email) => {
        for (const element of email?.attributes) {
            email[element.key] = element.value === 'true' || element.value === 'false'
                ? JSON.parse(element.value)
                : element.value;
        }
        return email;
    }) || [];
}